<template>
    <div style="width:100%">
      <div class="desc" >
        <div v-html="value"></div>
      </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {}
        },
        props: {
          value:{

          }
        }
    }
</script>
<style scoped lang="scss">
  div{
    font-size: 0.28rem;
  }
  .desc{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 0.12rem 0.3rem 0.3rem 0.3rem;
  }
  >>> img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/container/course.vue